import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import "./refferal2w.scss";
import { useDispatch } from "react-redux";
import { refferalPointsAction, postRefferalAction } from "../../actions/redemptionAction";
import { notify } from '../../services/notification';
import Validation from "../../constants/validation/Validation";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import moment from 'moment';
import useMobileView from "../../constants/useMobileView";

function Refferal2w() {
  const [states, setStates] = useState({
    referrer_amount: "",
    referee_amount: "",
    referrer_user_type_slug: "PGM",
    referee_user_type_slug: "PGM"
  });
  const [refferalpoint, setRefferalPoints] = useState([]);


  const [loading, setloading] = useState(false);
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const dispatch = useDispatch();

  useEffect(() => {
    getRefferalPoints();
  }, []);



  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setStates((prev) => ({
      ...prev,
      [name]: value.replace(/^ +/gm, ""),
    }));
  };

  async function getRefferalPoints() {
    setloading(true);
    var response = await dispatch(refferalPointsAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setRefferalPoints(response?.data?.data);
    }
    setloading(false);
  }

  const handleOnCreateClick = async () => {
    // const referrerAmount = parseInt(states?.referrer_amount) || 0;
    // const refereeAmount = parseInt(states?.referee_amount) || 0;

    // if (referrerAmount <= refereeAmount) {
    //     notify.error("Referrer Points must be greater than Referee Points");
    //     return;
    // }

    setloading(true);

    const apiReq = {
      referrer_user_type_slug: "pgm",
      referee_user_type_slug: "pgm",
      referrer_amount: Number(states.referrer_amount) || 0,
      referee_amount: Number(states.referee_amount) || 0
    };

    try {
      let response = await dispatch(postRefferalAction(apiReq));

      if (response?.status === HTTP_STATUS.SUCCESS) {
        notify.success(response?.data?.message || "Referral created successfully!");
        setStates({ referee_amount: "", referrer_amount: "" });

        setTimeout(() => {
          getRefferalPoints();
        }, 400);
      } else {
        notify.error(response?.data?.message || "Failed to create referral.");
      }
    } catch (error) {
      notify.error("An error occurred while creating the referral.");
    }

    setloading(false);
  };

  return (
    <div className="referrer-points-container">
      <div className="referrer-points-rightsidebar">
        <Header title="Referral" />
        {loading ? <Loader /> : (
          <div className="referrer-points-input-label">
              <div className="usertype">
              <div className="referrer-label">
                <div className="referrer-input-lable">
                  <label className="label-referrer-points">Select Referrer User Type</label>
                  <select
                    className="referrer-points-dropdown"
                    name="referrer_user_type_slug"
                    onChange={handleChange}
                    value={states.referrer_user_type_slug}
                  >
                    <option value="PGM">PGM</option>
                  </select>
                </div>
                <div className="referrer-input-lable">
                  <label className="label-referrer-points">Select Referee User Type</label>
                  <select
                    className="referrer-points-dropdown"
                    name="referee_user_type_slug"
                    onChange={handleChange}
                    value={states.referee_user_type_slug}
                  >
                    <option value="PGM">PGM</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="referrer-search">
              <div className="referrer-label">
                <div className="referrer-input-lable">
                  <div>
                  <label className="label-referrer-points">Referrer Points</label>
                  <div className="refferal-label-div">
                  <label className="refferal-label-text">(Existing PGM)</label>
                  </div>
                 </div>
                  <input type="text" className="referrer-points-input" maxLength={3} placeholder="Referrer Points" name="referrer_amount" value={states.referrer_amount} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
                </div>
                <div className="referrer-input-lable  ">
                <div>
                <label className="label-referrer-points">Referee Points</label>
                <div className="refferal-label-div">
                  <label className="refferal-label-text">(New PGM)</label>
                  </div>
                  </div>
                  <input type="text" className="referrer-points-input" maxLength={3} placeholder="Referee Points" name="referee_amount" value={states.referee_amount} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
                </div>
              </div>
              <div className="referrer-create">
                  <button
                    type="button"
                    className="referrer-points-create-button"
                    onClick={handleOnCreateClick}
                    disabled={!states.referee_amount || !states.referrer_amount}
                  >
                    Create
                  </button>
                </div>
            </div>
            <div className="table-referrer-points">
              <table className="table">
                <thead>
                  <tr>
                    <th className="tablesth">Referrer Points</th>
                    <th className="tablesth">Referee Points</th>
                    <th className="tablesth">Created on</th>
                    <th className="tablesth">Created by</th>
                  </tr>
                </thead>
                <tbody>
                  <tr >
                    <td className="tabletd">{refferalpoint?.[0]?.referrer_amount}</td>
                    <td className="tabletd">{refferalpoint?.[0]?.referee_amount}</td>
                    <td className="tabletd">
                      {moment(refferalpoint?.[0]?.created_at).utc().format('DD/MM/YYYY')}
                    </td>
                    <td className="tabletd">{refferalpoint?.[0]?.created_by_admin_user_name}</td>
                  </tr>
                </tbody>

              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Refferal2w;
